import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, take } from 'rxjs/operators';

import { AuthService } from '../service/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    return this.authService.user.pipe(
      take(1),
      map((user) => {
        const isAuth = !!user;
        if (isAuth) {
          // check MFA
          if(user.mfa_seed && !user.mfa_pass){
            return this.router.createUrlTree(['/mfa']);
          }
          else{
            return true;
          }
        }
        this.authService.redirect = router.url;
        return this.router.createUrlTree(['/login'], {
          queryParams: { r: router.url },
        });
      })
    );
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }
}
